import Dashboard from "horizon/views/dashboard/Dashboard";
import ElasticSearch from "./views/elasticsearch/ElasticSearch";
import UserPage from "./views/usersManage/User.js";
import AuditorProAndArtistes from "./views/usersManage/auditorProAndArtistes";
import DatabaseUpdate from "./views/adminTools/DatabaseUpdate";
import Certifications from "./views/certificationsManage/certifications";
import LegalDocuments from "./views/legalDocuments/LegalDocuments";
import ApiDocs from "./views/apiDocs/ApiDocs";
import Payments from "./views/payments/Payments";
import Treasury from "./views/treasury/Treasury";
import CurrencyRates from "./views/currencyRates/CurrencyRates";
import Notifications from "./views/notifications/Notifications";
import Subscriptions from "./views/subscriptionsManage/Subscriptions";
import Transactions from "./views/transactionsManage/Transactions";
import ContactCards from "./views/contactCardsManage/ContactCards";
import Services from "./views/servicesManage/Services";
import Reservations from "./views/reservationsManage/Reservations";
import ConfiscationRequests from "./views/confiscationRequests/ConfiscationRequests";
import AuditLog from "./views/auditLog/AuditLog";
import {
  MdOutlineDeveloperBoard as DeveloperBoardOutlinedIcon,
  MdRepartition as RepartitionIcon,
  MdDashboard as DashboardIcon,
  MdAdminPanelSettings as AdminPanelSettingsIcon,
  MdGroups as GroupsIcon,
  MdVerified as VerifiedIcon,
  MdPeople as PeopleIcon,
  MdAssignment as AssignmentIcon,
  MdStorage as StorageIcon,
  MdGavel as GavelIcon,
  MdMenuBook as MenuBookIcon,
  MdPayments as PaymentsIcon,
  MdAccountBalanceWallet as AccountBalanceWalletIcon,
  MdAccountBalance as AccountBalanceIcon,
  MdCurrencyExchange as CurrencyExchangeIcon,
  MdNotificationsActive as NotificationsIcon,
  MdCardMembership as CardMembershipIcon,
  MdPendingActions as PendingActionsIcon,
  MdContacts as ContactsIcon,
  MdLibraryMusic as LibraryMusicIcon,
  MdAudiotrack as AudiotrackIcon,
  MdEventNote as EventNoteIcon,
  MdFactCheck as FactCheckIcon,
  MdMoneyOff as MoneyOffIcon,
  MdHistory as HistoryIcon,
} from "react-icons/md";

let routes = [
  {
    path: "/dashboard",
    name: "Tableau de Bord",
    icon: DashboardIcon,
    component: Dashboard,
    layout: "/admin",
    engine: "chakra",
  },
  {
    type: "group",
    name: "Gestion des Comptes",
    icon: PeopleIcon,
    children: [
      {
        path: "/profile",
        name: "Administrateurs",
        icon: AdminPanelSettingsIcon,
        component: UserPage,
        layout: "/admin",
        engine: "chakra",
      },
      {
        path: "/auditor_pro_and_artists",
        name: "Artistes & Auditeurs",
        icon: GroupsIcon,
        component: AuditorProAndArtistes,
        layout: "/admin",
        engine: "chakra",
      }
    ]
  },
  {
    type: "group",
    name: "Demandes & Validations",
    icon: AssignmentIcon,
    children: [
      {
        path: "/certifications",
        name: "Certifications",
        icon: VerifiedIcon,
        component: Certifications,
        layout: "/admin",
        engine: "chakra",
      },
      {
        path: "/legal_documents",
        name: "Documents Légaux",
        icon: GavelIcon,
        component: LegalDocuments,
        layout: "/admin",
        engine: "chakra",
      },
      {
        path: "/transactions",
        name: "Paiements à valider",
        icon: PendingActionsIcon,
        component: Transactions,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
      {
        path: "/contact_cards",
        name: "Contacts",
        icon: ContactsIcon,
        component: ContactCards,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
    ]
  },
  {
    type: "group",
    name: "Catalogue",
    icon: LibraryMusicIcon,
    children: [
      {
        path: "/services",
        name: "Services",
        icon: AudiotrackIcon,
        component: Services,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
      {
        path: "/reservations",
        name: "Réservations",
        icon: EventNoteIcon,
        component: Reservations,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
    ]
  },
  {
    type: "group",
    name: "Finances",
    icon: AccountBalanceWalletIcon,
    children: [
      {
        path: "/payments",
        name: "Paiements & Remboursements",
        icon: PaymentsIcon,
        component: Payments,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
      {
        path: "/treasury",
        name: "Trésorerie par canal",
        icon: AccountBalanceIcon,
        component: Treasury,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
      {
        path: "/currency_rates",
        name: "Taux de change",
        icon: CurrencyExchangeIcon,
        component: CurrencyRates,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
      {
        path: "/subscriptions",
        name: "Abonnements",
        icon: CardMembershipIcon,
        component: Subscriptions,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
    ]
  },
  {
    type: "group",
    name: "Audit & Conformité",
    icon: FactCheckIcon,
    children: [
      {
        path: "/confiscation_requests",
        name: "Demandes de confiscation",
        icon: MoneyOffIcon,
        component: ConfiscationRequests,
        layout: "/admin",
        minRight: 2,
        engine: "chakra",
      },
      {
        path: "/audit_log",
        name: "Journal d'audit",
        icon: HistoryIcon,
        component: AuditLog,
        layout: "/admin",
        minRight: 2,
        engine: "chakra",
      },
      {
        path: "/notifications",
        name: "Notifications",
        icon: NotificationsIcon,
        component: Notifications,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
    ]
  },
  {
    type: "group",
    name: "Infrastructure & Outils",
    icon: StorageIcon,
    children: [
      {
        path: "/elastic",
        name: "ElasticSearch",
        icon: DeveloperBoardOutlinedIcon,
        component: ElasticSearch,
        layout: "/admin",
        engine: "chakra",
      },
      {
        path: "/admin_tools",
        name: "Outils d'Administration",
        icon: RepartitionIcon,
        component: DatabaseUpdate,
        layout: "/admin",
        minRight: 2,
        engine: "chakra",
      },
      {
        path: "/api_docs",
        name: "Documentation API",
        icon: MenuBookIcon,
        component: ApiDocs,
        layout: "/admin",
        minRight: 1,
        engine: "chakra",
      },
    ]
  },
];

export default routes;
